export const carouselImages = [
    // {
    //     "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png"
    // },
    {
        "imagen" : "./img/banner/carrusel1.png"
    },
    {
        "imagen" : "./img/banner/carrusel2.png"
    },
    {
        "imagen" : "./img/banner/carrusel4.png"
    },
    {
        "imagen" : "./img/banner/carrusel5.png"
    },

]